import { ReactElement } from "react";
import clsx from "clsx";

export const SheetSectionContainer = ({
  children,
  className,
}: {
  children: ReactElement[];
  className?: string;
}) => {
  return (
    <div
      className={clsx(
        "flex flex-col gap-4 border-t border-slate-200 py-6",
        className,
      )}
    >
      {children}
    </div>
  );
};
